module.exports = __webpack_public_path__ + "static/hero3-1fa6a8b11c74912bc6e224b016a03371.jpg";